import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class CashbackOfferFilterEntity {
  dateRange?: string[]
  page?: number
  limit?: number
  isActive?: boolean
  branch?: BranchMiniEntity
  region?: RegionMiniEntity
  regionId?: number
}
